export default function Center({children, height}) {
  const style = height ? {height} : undefined;
  return (
    <div className='flex justify-center items-center' style={style}>{children}</div>
  )
}
